import { render, staticRenderFns } from "./ProgressStats.vue?vue&type=template&id=0efbe172&scoped=true&"
import script from "./ProgressStats.vue?vue&type=script&lang=js&"
export * from "./ProgressStats.vue?vue&type=script&lang=js&"
import style0 from "./ProgressStats.vue?vue&type=style&index=0&id=0efbe172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbe172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efbe172')) {
      api.createRecord('0efbe172', component.options)
    } else {
      api.reload('0efbe172', component.options)
    }
    module.hot.accept("./ProgressStats.vue?vue&type=template&id=0efbe172&scoped=true&", function () {
      api.rerender('0efbe172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProgressStats.vue"
export default component.exports